import React, {
  useCallback,
  useEffect, useState,
} from 'react';
import { T2 } from '../../../styles/titles';
import LoadingOverlay from '../../../components/LoadingOverlay';
import { getAxiosInstanceLinkPagamento } from "../../../services/providers/api";
import { Button, Container } from './styles';
import LiveTable from "./liveTable";
import LinkDePagamentoService from "../service/linkDePagamentoService";
import { getErrorMessage } from "../../../utils/getErrorMessage";
import { FormValues } from '../../terminaisPhoebus/types';
import { can, PortalPermissions } from "../../../config/permissions";

const ListarLinks: React.FC = () => {
  const linkDePagamentoServices = new LinkDePagamentoService();
  const selectedBusiness = localStorage.getItem('selectedCompany') ? JSON.parse(localStorage.getItem('selectedCompany') as string) : null;
  const user = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') as string) : null;
  const [links, setLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getLinksDePagamento()
  }, []);

  const getLinksDePagamento = async () => {
    try {
      setIsLoading(true);
      const response = await linkDePagamentoServices.getAllLinks(selectedBusiness, user);
      setLinks(response);
    }

    catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
    }

    finally {
      setIsLoading(false);
    }
  }
  const handleDownload = async () => {
    setIsLoading(true);
    try {
      await linkDePagamentoServices.downloadRelatorioLinks();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <LoadingOverlay
        show={isLoading}
        relative
      />
      <T2>Links de pagamento</T2>
      <div>
        {can(PortalPermissions.linkPagamento.historico.exportar) && (
          <Button
            onClick={handleDownload}
            style={{ marginBottom: '20px', marginRight: '24px', width: '150px', alignSelf: 'end' }}
          >
            Download Xlsx
          </Button>
        )}
      </div>
      <LiveTable setLink={setLinks} dataFilter={links} />

    </Container>
  );
}
export default ListarLinks;